import type { PlanAndRateOverrideParams } from '../../../api/dto/plan-and-rate-override-rules.dto'

export const numFormatter = (p: { value: unknown }): string => {
  const v = p.value
  if (v == null || v === 'null') return '—'
  const n = Number(v)
  return Number.isFinite(n) ? n.toFixed(3) : '—'
}

export interface SelectOption {
  value: string
  label: string
}

export const PLAN_TYPE_OPTIONS: SelectOption[] = [
  { value: 'HMO', label: 'HMO' },
  { value: 'PPO', label: 'PPO' },
  { value: 'EPO', label: 'EPO' },
  { value: 'POS', label: 'POS' },
  { value: 'HDHP', label: 'HDHP' },
  { value: 'HDHP_HRA', label: 'HDHP/HRA' },
]

export const LEVEL_OPTIONS: SelectOption[] = [
  { value: 'BRONZE', label: 'Bronze' },
  { value: 'SILVER', label: 'Silver' },
  { value: 'GOLD', label: 'Gold' },
  { value: 'PLATINUM', label: 'Platinum' },
  { value: 'CATASTROPHIC', label: 'Catastrophic' },
  { value: 'EXPANDED_BRONZE', label: 'Expanded Bronze' },
]

export const PLAN_STATUS_OPTIONS: SelectOption[] = [
  { value: 'DRAFT', label: 'Draft' },
  { value: 'APPROVED', label: 'Approved' },
  { value: 'REJECTED', label: 'Rejected' },
]

export function normalizeParams(
  params: PlanAndRateOverrideParams
): PlanAndRateOverrideParams {
  const p = params ?? {}
  return {
    carrier: p.carrier ?? null,
    planName: p.planName ?? null,
    householdName: p.householdName ?? null,
    planType: p.planType ?? null,
    level: p.level ?? null,
    hsa: p.hsa ?? undefined,
    networkName: p.networkName ?? null,
    onExchange: p.onExchange ?? undefined,
    offExchange: p.offExchange ?? undefined,
    isForSale: p.isForSale ?? undefined,
    proofOfResidenceRequired: p.proofOfResidenceRequired ?? undefined,
    serviceAreaId: p.serviceAreaId ?? null,
    baseRate: p.baseRate ?? null,
    planFee: p.planFee ?? null,
    planStatus: p.planStatus ?? null,
    crosswalkPlanId: p.crosswalkPlanId ?? null,
    rateAdjustments: p.rateAdjustments,
  }
}
